export const CACHE_FORM_DATA = 'CACHE_FORM_DATA';

export const cacheFormData = (values, actionIdentifier) => dispatch => {
    return dispatch({ type: CACHE_FORM_DATA, payload: { values, actionIdentifier } });
};



// WEBPACK FOOTER //
// ./src/utils/formCaching/actions.js